/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  // Image protection
(function() {
  function protectImages() {
    document.querySelectorAll('img').forEach(function(img) {
      img.draggable = false;
      img.style.userSelect = 'none';
      img.style.webkitUserSelect = 'none';
      img.addEventListener('contextmenu', function(e) { e.preventDefault(); });
      img.addEventListener('dragstart', function(e) { e.preventDefault(); });
      img.addEventListener('mousedown', function(e) { if (e.button === 2) e.preventDefault(); });

    // Proteger videos
    document.querySelectorAll('video').forEach(function(video) {
      video.addEventListener('contextmenu', function(e) { e.preventDefault(); });
      video.controlsList = 'nodownload';
      video.setAttribute('controlsList', 'nodownload');
      video.oncontextmenu = function() { return false; };
  });
    });

    // Proteger también imágenes de fondo y elementos con background-image
    document.querySelectorAll('[style*="background-image"]').forEach(function(el) {
      el.addEventListener('contextmenu', function(e) { e.preventDefault(); });
    });
  }

  // Ejecutar al cargar
  protectImages();

  // Re-ejecutar cuando Shopify carga contenido dinámico (sliders, quickviews, etc.)
  var observer = new MutationObserver(function() {
    protectImages();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Bloquear clic derecho general en toda la página
  document.addEventListener('contextmenu', function(e) {
    if (e.target.tagName === 'IMG' || e.target.closest('[style*="background-image"]')) {
      e.preventDefault();
    }
  });

  // Bloquear atajos de teclado de guardar/inspeccionar
  document.addEventListener('keydown', function(e) {
    // Bloquear Ctrl+S / Cmd+S (guardar página)
    if ((e.ctrlKey || e.metaKey) && e.key === 's') {
      e.preventDefault();
    }
    // Bloquear Ctrl+U / Cmd+U (ver fuente)
    if ((e.ctrlKey || e.metaKey) && e.key === 'u') {
      e.preventDefault();
    }
  });
})();


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
